export default __webpack_public_path__ + "static/media/language-translation-and-linguistics-icon-vector-14239078.19e98cc2.jpeg";